type Props = {
  title: string;
  buttonGroup?: any;
};

export const PageHeader = ({ title, buttonGroup }: Props) => {
  return (
    <div className="block justify-between page-header md:flex">
      <div>
        <h3 className="text-gray-700 hover:text-gray-900 dark:text-white dark:hover:text-white text-2xl font-medium">
          {title}
        </h3>
      </div>
      <div>{buttonGroup}</div>
    </div>
  );
};
